import { api } from 'app/config/apiConfig';

export const sendDebtorLastNotificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendDebtorLastNotification: builder.mutation<void, string>({
      query: (contractId) => ({
        url: `/contracts/${contractId}/send-debtor-notification`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useSendDebtorLastNotificationMutation } = sendDebtorLastNotificationApi;
